import { useUserRepository } from '@ayocore/platform/identity/client/rpc';
import { createRepositoryFilter } from '@ayocore/platform/client/components/RepositoryTable/createRepositoryFilter';
import type { PartnerRepository } from '@ayocore/erp/crm/server/repositories/PartnerRepository';

type UserRepo = ReturnType<typeof useUserRepository>;

/**
 * Фильтр партнёров по менеджеру (single).
 * Список включает и уволенных/деактивированных менеджеров (onlyHuman, без фильтра
 * по is_active) — нужны для отчётов по партнёрам бывших сотрудников. Активные менеджеры
 * идут первыми (orderBy 'is_active' desc), внутри группы — по алфавиту (orderByName).
 * Опция «Без менеджера» (XOR) фильтрует партнёров с пустым manager_id.
 */
export const FilterByManager = createRepositoryFilter<PartnerRepository, UserRepo>({
  name: 'manager',
  placeholder: 'Выберите менеджера...',
  width: 170,
  source: () => useUserRepository().onlyHuman().orderBy('is_active', 'desc').orderByName('asc'),
  displayField: 'name',
  by: (repo, id) => repo.filterByManager(id),
  without: { label: 'Без менеджера', apply: repo => repo.filterWithoutManager() },
});
